import { createGlobalState } from '@vueuse/shared';
import type { Ref } from 'vue';
import { ref } from 'vue';

export const usePortfolioUnderAnalysisAttributesGlobalState = createGlobalState(
  (): {
    isConstituentPortfolio: Ref<boolean | null>;
    isLivePortfolio: Ref<boolean | null>;
    isCustomRebalancingPortfolio: Ref<boolean | null>;
    isEquityBasketPortfolio: Ref<boolean | null>;
    isQISBasketPortfolio: Ref<boolean | null>;
    isBasketTypePortfolio: Ref<boolean | null>;
    hasCustomRebalancingPortfolio: Ref<boolean | null>;
    isPeerGroupPortfolio: Ref<boolean | null>;
    hasFlattenedActiveCodes: Ref<boolean | null>;
    shouldExposePositions: Ref<boolean | null>;
    containsOnlyEquities: Ref<boolean | null>;
  } => {
    const isConstituentPortfolio = ref<boolean | null>(null);
    const isLivePortfolio = ref<boolean | null>(null);
    const isCustomRebalancingPortfolio = ref<boolean | null>(null);
    const isEquityBasketPortfolio = ref<boolean | null>(null);
    const isQISBasketPortfolio = ref<boolean | null>(null);
    const isBasketTypePortfolio = ref<boolean | null>(null);
    const hasCustomRebalancingPortfolio = ref<boolean | null>(null);
    const isPeerGroupPortfolio = ref<boolean | null>(null);
    const hasFlattenedActiveCodes = ref<boolean | null>(null);
    const shouldExposePositions = ref<boolean | null>(null);
    const containsOnlyEquities = ref<boolean | null>(null);

    return {
      isConstituentPortfolio,
      isLivePortfolio,
      isCustomRebalancingPortfolio,
      isEquityBasketPortfolio,
      isQISBasketPortfolio,
      isBasketTypePortfolio,
      isPeerGroupPortfolio,
      hasCustomRebalancingPortfolio,
      hasFlattenedActiveCodes,
      shouldExposePositions,
      containsOnlyEquities,
    };
  },
);
